import * as yup from 'yup'

export const logInSchema = yup.object().shape({
  username: yup
    .string('Debe ingresar un nombre de usuario')
    .required('Debe ingresar un nombre de usuario'),
  password: yup
    .string('Debe ingresar una contraseña')
    .required('Debe ingresar una contraseña')
})

export const otpSchema = yup.object().shape({
  firstDigit: yup.number().typeError('Debe ingresar un número').required(),
  secondDigit: yup
    .number('Debe completar el segundo dígito del código')
    .required('Debe completar el segundo dígito código'),
  thirdDigit: yup
    .number('Debe completar el tercer dígito del código')
    .required('Debe completar el tercer dígito código'),
  fourthDigit: yup
    .number('Debe completar el cuarto dígito del código')
    .required('Debe completar el cuarto dígito código')
})
